export default "__VITE_ASSET__2fa8098b__"